import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bdc1a74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "second-header__container" }
const _hoisted_2 = { class: "second-header__container-first-title" }
const _hoisted_3 = { class: "items-in-column" }
const _hoisted_4 = {
  key: 0,
  class: "second-header__container-title-box"
}
const _hoisted_5 = { class: "font-size-title-block" }
const _hoisted_6 = { class: "second-header__container-actions" }
const _hoisted_7 = { class: "items-in-line gap--10 flex-start" }
const _hoisted_8 = { class: "items-in-line gap--10" }
const _hoisted_9 = { class: "items-in-line only-mobile" }
const _hoisted_10 = {
  key: 0,
  class: "second-header__container-first-horizontal-divider"
}
const _hoisted_11 = { class: "second-header__container-second none-Mobile" }
const _hoisted_12 = { class: "second-header__container-second-divider" }
const _hoisted_13 = { class: "second-header__container-right-box" }
const _hoisted_14 = { class: "items-in-line" }

import { PhoneButton, ShareBtn } from '@/components';
import { useChatStore } from '@/store/modules/chat';


export default /*#__PURE__*/_defineComponent({
  __name: 'SecondHeader',
  props: /*#__PURE__*/_mergeModels({
    offerCardUrl: {},
    title: {},
    phone: {},
    logo: {},
    isSticky: { type: Boolean, default: true }
  }, {
    "modelValue": { type: Boolean },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;

// eslint-disable-next-line no-undef
const showBlock = _useModel<boolean>(__props, "modelValue");

return (_ctx: any,_cache: any) => {
  const _component_base_image = _resolveComponent("base-image")!
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_divider = _resolveComponent("base-divider")!
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createBlock(_component_base_card, {
    class: _normalizeClass([{ isSticky: _ctx.isSticky }, "mb--20 second-header"])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass([{ withBlock: _ctx.$slots.data }, "second-header__container-first"])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_base_image, {
              src: _ctx.logo,
              contain: "",
              height: "70",
              name: "seller",
              version: "v7",
              width: "70"
            }, null, 8, ["src"]),
            _createElementVNode("div", _hoisted_3, [
              (!_ctx.$slots.title)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("span", _hoisted_5, " Результаты проверки: " + _toDisplayString(_ctx.title), 1),
                    _createVNode(_component_base_icon, {
                      class: _normalizeClass([{ open: showBlock.value }, "second-header__container-expand-icon only-mobile"]),
                      clickable: "",
                      color: "#009D3E",
                      name: "expand_more",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (showBlock.value = !showBlock.value))
                    }, null, 8, ["class"])
                  ]))
                : _createCommentVNode("", true),
              _renderSlot(_ctx.$slots, "title"),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  (_ctx.phone && _ctx.phone.length)
                    ? (_openBlock(), _createBlock(_unref(PhoneButton), {
                        key: 0,
                        phone: _ctx.phone,
                        iconMobile: ""
                      }, null, 8, ["phone"]))
                    : _createCommentVNode("", true),
                  (_ctx.offerCardUrl)
                    ? (_openBlock(), _createBlock(_component_base_button, {
                        key: 1,
                        "all-block-width": "",
                        class: "none-Mobile",
                        "style-type": "coloredBorder",
                        text: "Чат",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(useChatStore)().openMiniMessenger(undefined, _ctx.offerCardUrl)))
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.offerCardUrl)
                    ? (_openBlock(), _createBlock(_component_base_button, {
                        key: 2,
                        class: "only-mobile",
                        icon: "",
                        "style-type": "greenBorder",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(useChatStore)().openMiniMessenger(undefined, _ctx.offerCardUrl)))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_base_icon, {
                            color: "#009D3E",
                            "font-size": "20",
                            name: "mail"
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _renderSlot(_ctx.$slots, "btn"),
                  _createElementVNode("span", _hoisted_9, [
                    _createVNode(_unref(ShareBtn), {
                      "btn-type": "greenBorder",
                      color: "#009D3E",
                      "font-size": "20",
                      height: "28",
                      width: "28"
                    })
                  ])
                ])
              ])
            ])
          ]),
          (_ctx.$slots.data)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_base_divider)
              ]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "data")
        ], 2),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_base_divider, { vertical: "" })
          ]),
          _createElementVNode("span", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, [
              _createVNode(_unref(ShareBtn))
            ]),
            _createElementVNode("button", {
              class: "gradient-color",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (showBlock.value = !showBlock.value))
            }, _toDisplayString(showBlock.value ? 'Свернуть' : 'Развернуть'), 1)
          ])
        ])
      ])
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})